import { gql } from "@apollo/client";
import { ParcelSimpleInfoFragment } from "graphql/Parcel/fragments";
import { ReceiverInfoFragment } from "graphql/Receiver/fragments";
import { ActivityInfoFragment } from "graphql/User/fragments";

export const OrderInfoFragment = gql`
  fragment OrderInfo on Order {
    _id
    order_UID
    order_status
    order_date
    order_time
    order_created_at
    order_receiver {
      ...ReceiverInfo
    }
    order_parcels {
      ...ParcelSimpleInfo
    }
    relay {
      name
      types
      location {
        address
      }
    }

    order_activities {
      ...ActivityInfo
    }
  }
  ${ReceiverInfoFragment}
  ${ParcelSimpleInfoFragment}
  ${ActivityInfoFragment}
`;

